import { FilterParams } from '@statsbomb/parachute-types';
import { EXPORT_TYPE } from '@/consts/exporting';
import { Nullable } from './generic';

export type ExportType = keyof typeof EXPORT_TYPE;

export enum ExportContent {
  VIS_TABLE = 'visTable',
  VIS = 'vis',
  TABLE = 'table',
}

export type ExportModalData = {
  visName: string;
  templateName?: string;
  secondaryTitlePrefix?: string;
  customWidth?: number;
  content?: ExportContent;
};

export type ExportModalProps = Omit<ExportModalData, 'content'>;

export type CsvDownloadOptions = {
  includeOnDemandMetrics?: boolean;
  appliedFilters?: Nullable<FilterParams>;
};

export type CsvDownloadData = {
  url: string;
  fileName: string;
} & CsvDownloadOptions;
